/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	FREE_EDITION,
	getEdition,
	STANDARD_EDITION,
	PREMIUM_EDITION,
	UNLICENSED,
} from '@jira/platform__application-editions/src/edition.tsx';
import { JIRA_SOFTWARE } from '@jira/platform__application-editions/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useIsFreeJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === FREE_EDITION;
};

export const useIsStandardOrFreeJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === STANDARD_EDITION || jswEdition === FREE_EDITION;
};

export const useIsPremiumJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === PREMIUM_EDITION;
};

export const useIsUnlicensedJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return !jswEdition || jswEdition === UNLICENSED;
};
